import React from 'react';
import styles from './mobileMenu.module.scss';
import ItemMenu from '../../ItemMenu/ItemMenu';
import { t } from 'components/translation/Translation';
import { useToggle } from 'hooks/useToggle';
import { useClickOutside } from 'hooks/useClickOutside';
import { useOnChangeLocation } from 'hooks/useOnChangeLocations';
import { Menu24 } from '@carbon/icons-react';
import ProfileMenu from '../profile-menu/ProfileMenu';

const MobileMenu = ({ routesNav, routesProfileMenu, openSettings, openResetPassword, fullname }) => {
  const modified = [{ ...routesNav[0], displayName: t('parent:layout.explore') }, ...routesNav.slice(1, 3)];

  const menu = [{ displayName: t('parent:layout.more'), to: null, icon: <Menu24 /> }];

  const [showProfileMenu, onToggleProfileMenu, onCloseMenu] = useToggle(false);

  const domRef = useClickOutside(() => {
    if (showProfileMenu) onToggleProfileMenu();
  });

  useOnChangeLocation(() => onCloseMenu());

  return (
    <>
      <div className={styles.mobile_nav}>
        {modified.map((route, index) => (
          <ItemMenu className={styles.item} {...route} key={index} />
        ))}

        <div className="cursor-pointer" onClick={onToggleProfileMenu} ref={domRef} data-testid="menuBtn">
          {menu.map((route, index) => (
            <ItemMenu
              className={styles.item}
              {...route}
              key={index}
              onClick={onToggleProfileMenu}
              innerRef={domRef}
              ref={domRef}
            />
          ))}
        </div>
      </div>
      {showProfileMenu && (
        <ProfileMenu
          ref={domRef}
          routesProfileMenu={routesProfileMenu}
          openSettings={openSettings}
          openResetPassword={openResetPassword}
          fullname={fullname}
        />
      )}
    </>
  );
};

export default MobileMenu;
